export * from './loyalty-logo-widget.styled.default';
